import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {MensajePagosPage} from '../modules/mensajePagos/MensajePagosPage'
import {useAuth, AxiosInterceptor} from '../modules/auth' // Importar AxiosInterceptor

const PrivateRoutes = () => {
  // Usar el hook de autenticación para obtener el auth actual
  const {auth} = useAuth()
  const rolActual = auth?.usuarioGc_Track?.rol

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const PerfilPage = lazy(() => import('../modules/myProfile/PerfilPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const PanelsPage = lazy(() => import('../modules/apps/panel-management/PanelsPage'))
  const CompanyPage = lazy(() => import('../modules/apps/company-management/CompanyPage'))
  const OrdenesPage = lazy(() => import('../modules/apps/ordenes-management/PaginaOrdenes'))
  const ProductsPage = lazy(() => import('../modules/apps/productos-management/PaginaProductos'))
  const PromocionesPage = lazy(() => import('../modules/apps/promociones-management/UsersPage'))
  const LogsPage = lazy(() => import('../modules/apps/logs-management/LogsPage'))
  const GCUsersPage = lazy(() => import('../modules/apps/userGCTrack-management/UsersPage'))
  const PrivacyPage = lazy(() => import('../modules/privacy/PrivacyPage'))

  return (
    <AxiosInterceptor>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          <Route path='auth/*' element={<Navigate to='/apps/ordenes-management' />} />
          {/* Pages */}

          <Route
            path='apps/ordenes-management/*'
            element={
              <SuspensedView>
                <OrdenesPage />
              </SuspensedView>
            }
          />

          <Route
            path='modules/privacy'
            element={
              <SuspensedView>
                <PrivacyPage />
              </SuspensedView>
            }
          />

          <Route
            path='crafted/mi-perfil/*'
            element={
              <SuspensedView>
                <PerfilPage />
              </SuspensedView>
            }
          />
          <Route
            path='apps/panel-management/*'
            element={
              <SuspensedView>
                <PanelsPage />
              </SuspensedView>
            }
          />

          {rolActual === 'Distribuidor' && (
            <>
              <Route path='dashboard' element={<DashboardWrapper />} />
              <Route path='builder' element={<BuilderPageWrapper />} />
              <Route path='menu-test' element={<MenuTestPage />} />
              {/* Lazy Modules */}
              <Route
                path='crafted/pages/profile/*'
                element={
                  <SuspensedView>
                    <ProfilePage />
                  </SuspensedView>
                }
              />
              <Route
                path='crafted/pages/wizards/*'
                element={
                  <SuspensedView>
                    <WizardsPage />
                  </SuspensedView>
                }
              />
              <Route
                path='crafted/widgets/*'
                element={
                  <SuspensedView>
                    <WidgetsPage />
                  </SuspensedView>
                }
              />
              <Route
                path='crafted/account/*'
                element={
                  <SuspensedView>
                    <AccountPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/chat/*'
                element={
                  <SuspensedView>
                    <ChatPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/ordenes/*'
                element={
                  <SuspensedView>
                    <OrdenesPage />
                  </SuspensedView>
                }
              />

              <Route
                path='apps/user-management/*'
                element={
                  <SuspensedView>
                    <UsersPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/company-management/*'
                element={
                  <SuspensedView>
                    <CompanyPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/productos-management/*'
                element={
                  <SuspensedView>
                    <ProductsPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/promociones-management/*'
                element={
                  <SuspensedView>
                    <PromocionesPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/logs-management/*'
                element={
                  <SuspensedView>
                    <LogsPage />
                  </SuspensedView>
                }
              />
              <Route
                path='apps/userGCTrack-management/*'
                element={
                  <SuspensedView>
                    <GCUsersPage />
                  </SuspensedView>
                }
              />
            </>
          )}

          <Route
            path='apps/pagoRealizado/*'
            element={
              <SuspensedView>
                <MensajePagosPage />
              </SuspensedView>
            }
          />
          {/* Page Not Found */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </AxiosInterceptor>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
